import styled from "styled-components/macro";

export const NewProjectCardContainer = styled.div`
  position: relative;
  width: min(100%, 229px);
  aspect-ratio: 2 / 3;
  align-self: start;
  min-width: 0;
  box-sizing: border-box;
  border: 1px solid color-mix(in srgb, var(--grey-1) 34%, transparent);
  border-radius: 4px;
  background: transparent;
  color: var(--grey-1);
  transition:
    background-color 180ms ease,
    border-color 180ms ease,
    box-shadow 180ms ease,
    transform 180ms ease;

  &:hover:not(.open),
  &:focus-within:not(.open) {
    border-color: color-mix(in srgb, var(--grey-1) 50%, transparent);
    background-color: color-mix(in srgb, var(--menu-color-fullscreen) 58%, transparent);
    box-shadow: 0 4px 12px rgb(0 0 0 / 16%);
    transform: translateY(-2px);
  }

  &.open {
    border-color: color-mix(in srgb, var(--grey-1) 50%, transparent);
    background-color: color-mix(in srgb, var(--menu-color-fullscreen) 36%, transparent);
    box-shadow: 0 2px 8px rgb(0 0 0 / 12%);
  }

  &:active:not(.open) {
    transform: scale(0.985);
  }

  .new-project-card-trigger {
    appearance: none;
    width: 100%;
    height: 100%;
    border: 0;
    background: transparent;
    color: var(--grey-1);
    cursor: pointer;
    font-family: "GT Super Text";
    font-size: 29px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 16px;
    border-radius: inherit;

    &:focus-visible {
      outline: 2px solid var(--primary-cta);
      outline-offset: 2px;
    }
  }

  .new-project-card-tour-anchor {
    position: absolute;
    top: 0;
    left: 50%;
    pointer-events: none;
  }

  .add-icon {
    width: 25px;
    height: 25px;
    flex-shrink: 0;

    path {
      fill: currentColor !important;
    }
  }

  .new-project-actions {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 6px;
    padding: 26px;
    box-sizing: border-box;
    isolation: isolate;
  }

  .new-project-action {
    box-sizing: border-box;
    width: auto;
    min-width: 0;
    height: 40px;
    justify-content: flex-start;
    border: 0 !important;
    border-radius: 8px !important;
    background: var(--menu-color-fullscreen) !important;
    box-shadow: var(--card-drop-shadow);
    color: var(--grey-0) !important;

    &::before {
      border-radius: 8px !important;
      background: transparent !important;
    }

    &:hover,
    &:focus-visible {
      border-radius: 8px !important;
      background: var(--menu-color-fullscreen-hover) !important;
    }

    &:hover::before,
    &:focus-visible::before,
    &:active::before {
      width: 100%;
      height: 100%;
      border-radius: 8px !important;
      background: transparent !important;
    }

    svg {
      flex-shrink: 0;

      path {
        fill: currentColor !important;
      }
    }
  }
`;
